import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowRedoDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-redo-down, forward"} maskId="square-filled-radius-0-stroke-1-IconArrowRedoDown"><path d="M19.7927 15.5L16.2928 18.9999L16.9999 19.707L21.707 14.9999L16.9999 10.2928L16.2928 10.9999L19.7929 14.5H3V6H12.5V5H2V15.5H19.7927Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowRedoDown;
